import { utils } from "@hh/global.js";

class SearchSection extends HTMLElement {
  constructor() {
    super();

    this.searchForm = this.querySelector(".js-search-form");
    this.searchInput = this.querySelector(".js-search-input");
    this.productsWrapper = this.querySelector(".js-products");
    this.sortSelector = this.querySelector(".js-sort select");
    this.searchTimeOut = "";

    /*
     * Existing customization preserved:
     * Normalize search terms before normal form submission.
     */
    this.searchForm.addEventListener("submit", () => {
      this.searchInput.value = this.normalizeSearchTerm(
        this.searchInput.value
      );
    });

    this.searchForm.addEventListener("keyup", () => {
      this.searchTimeOut && clearTimeout(this.searchTimeOut);

      this.searchTimeOut = setTimeout(() => {
        this.searchProducts();
      }, 500);
    });

    this.sortSelector.addEventListener(
      "change",
      this.searchProducts.bind(this)
    );
  }

  /*
   * Existing customization preserved.
   */
  normalizeSearchTerm(term = "") {
    return term
      .replace(/[-–—]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  changeCurrentUrl(e, t) {

    /*
     * ============================================================
     * OLD CODE COMMENTED OUT START
     * URL did not include the Shopify product-only search type.
     * ============================================================
     */

    // history.pushState(
    //   {},
    //   null,
    //   `/search?q=${encodeURIComponent(e)}${t ? `&${t}` : ""}`
    // );

    /*
     * ============================================================
     * OLD CODE COMMENTED OUT END
     * ============================================================
     */


    /*
     * ============================================================
     * CUSTOMIZATION START - PRODUCT ONLY SEARCH URL
     * Keep type=product in the browser URL so search results are
     * restricted to Shopify products only.
     * ============================================================
     */

    history.pushState(
      {},
      null,
      `/search?q=${encodeURIComponent(e)}&type=product${t ? `&${t}` : ""}`
    );

    /*
     * ============================================================
     * CUSTOMIZATION END - PRODUCT ONLY SEARCH URL
     * ============================================================
     */
  }

  async searchProducts() {
    const e = this.normalizeSearchTerm(
      this.searchInput?.value || ""
    );

    const t = this.sortSelector.value;


    /*
     * ============================================================
     * OLD CODE COMMENTED OUT START
     * AJAX search previously sent only the sort parameter.
     * ============================================================
     */

    // const r = await utils.fetchSearchResults(e, t);

    /*
     * ============================================================
     * OLD CODE COMMENTED OUT END
     * ============================================================
     */


    /*
     * ============================================================
     * CUSTOMIZATION START - PRODUCT ONLY AJAX SEARCH
     * Always send type=product.
     * Preserve the selected Shopify sorting parameter as well.
     * ============================================================
     */

    const searchParams = t
      ? `type=product&${t}`
      : "type=product";

    const r = await utils.fetchSearchResults(
      e,
      searchParams
    );

    /*
     * ============================================================
     * CUSTOMIZATION END - PRODUCT ONLY AJAX SEARCH
     * ============================================================
     */

    this.changeCurrentUrl(e, t);

    document.querySelector("title").innerHTML =
      r?.querySelector("title")?.innerHTML || document.querySelector("title").innerHTML;

    this.querySelector(".js-searched-status").innerHTML =
      r?.querySelector(".js-searched-status")?.innerHTML || "";

    this.querySelector(".js-searched-products").innerHTML =
      r?.querySelector(".js-searched-products")?.innerHTML || "";
  }
}

customElements.define("search-section", SearchSection);